'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var COREX_LIMITS_UPDATED = 'corex-limits:updated';

exports.COREX_LIMITS_UPDATED = COREX_LIMITS_UPDATED;
